export default __webpack_public_path__ + "static/media/noResultsCharts.f90d7d52.svg";